import { useTranslation } from 'react-i18next'

import { QA_NAME_SHOW_MORE_BUTTON } from '../../../../constants/qa'
import { ButtonArrow } from '../../../Button'
import Text from '../../../Text'

import * as styles from './ShowContentButton.module.css'

function ShowContentButton({ open, onClick }) {
  const { t } = useTranslation()

  return (
    <div className={styles.ShowContentButton} onClick={onClick}>
      <Text isSecondary>
        {t(open ? 'Email.ShowLessBtnKey' : 'Email.ShowMoreBtnKey')}
      </Text>
      <ButtonArrow isOpen={open} qaName={QA_NAME_SHOW_MORE_BUTTON} />
    </div>
  )
}

export default ShowContentButton
